import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { VoiceControlService } from '../../services/voice-control.service';
import { Config, Modality } from '../../models/configuration.model';
import { MultimodalService } from 'src/app/services/multimodal.service';
import { AudioService } from 'src/app/services/audio.service';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-multimodal',
  templateUrl: './multimodal.component.html',
  styleUrls: ['./multimodal.component.css']
})
export class MultimodalComponent implements OnInit {

  speechData: string;
  speechOutput: string;
  voiceControl = false;


  public config: Config;

  constructor(@Inject(DOCUMENT) private document: Document, private voiceControlService: VoiceControlService,
             private multimodalService: MultimodalService, private router: Router) {

    this.speechData = "";
    this.config = this.multimodalService.config;
    this.voiceControlService.config = this.config;


    this.voiceControlService.updateModality.subscribe(res => {
      let modality = this.config.modalities.filter(m => m.name === res.modality)[0];
      if (modality.active !== res.state) {
        (this.document.getElementById(modality.name) as HTMLElement).click();
      }
    });


  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    event.stopImmediatePropagation();

    const key = event.key;
    if (!this.config.inputFocus) {
      if (key === 's') {
        (this.document.getElementById(this.config.modalities[3].name) as HTMLElement).click();
      } else if (key === 'm') {
        (this.document.getElementById(this.config.modalities[2].name) as HTMLElement).click();
      } else if (key === 'h') {
        (this.document.getElementById(this.config.modalities[0].name) as HTMLElement).click();
      } else if (key === 'v') {
        (this.document.getElementById(this.config.modalities[1].name) as HTMLElement).click();
      }
    }
  }


  navigateTo(link: string) {
    this.router.navigate(['', link ]);
    window.scrollTo(0,0);
    this.hideImagePreview();
  }

  hideImagePreview() {
    this.document.getElementById('image-cursor').style.backgroundImage = 'none';
    this.document.getElementById('image-cursor').style.opacity = '0';
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.multimodalService.loadAudio();
  }

  selectModality(modality: Modality) {
    modality.active = !modality.active;
    this.multimodalService.playAudioClick();
    this.multimodalService.playHapticButtonClick(100);

    if (modality.name === 'speech') {
      if (modality.active) {
        this.voiceControl = true;
        setTimeout(() => {
          this.voiceControlService.initializeSpeechRecognition();
        }, 100);
      } else {
        this.voiceControlService.disableSpeechRecognition();
        this.voiceControl = false;
      }
    }
    this.voiceControlService.config = this.config;
  }

  activateSpeechRecognition() {
    this.voiceControlService.activateSpeechRecognition();
  }

  speak() {
    this.voiceControlService.genericMessage();
  }


  updateTheme(theme: string) {
    this.multimodalService.config.theme = theme;
    this.multimodalService.updateTheme(this.multimodalService.config.theme);
  }



}
